/**
 * A soft entrance for every routed page: 6px rise and fade over ~220ms,
 * keyed on the pathname so it plays once per navigation and never on
 * query-string changes (tabs, drawers). No exit animation: the old page
 * leaves instantly so navigation never feels slower than before.
 */
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useLocation } from "react-router-dom";

export const PageTransition: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const reduced = useReducedMotion();

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className="min-h-full"
      initial={reduced ? false : { opacity: 0, y: 6 }}
      key={pathname}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
